import { LocalStorageService } from './../../../../core/services/local-storage.service';
import { environment } from './../../../../../environment/environment';
import { SalarieService } from './../../../../core/services/salarie-service/salarie.service';
import { SortDataService } from './../../../../core/services/sortdata';
import { EsnCandidatService } from './../../../../core/services/esn-candidat/esn-candidat.service';
import { EsnAppeloffreService } from './../../../../core/services/esn-appeloffre/esn-appeloffre.service';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import {
  EmptyCV,
  obligationSelect,
  serverError,
} from './../../../../core/models/messages';
import { Country, IState, State } from 'country-state-city';
import * as saveAs from 'file-saver';
import * as JSZip from 'jszip';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { translations } from '../../../../core/models/call-offer';

@Component({
  selector: 'app-call-offer-suggestion',
  templateUrl: './call-offer-suggestion.component.html',
  styleUrls: ['./call-offer-suggestion.component.css'],
})
export class CallOfferSuggestionComponent {
  toggleCollapsible() {
    this.isCollapsed = !this.isCollapsed;
  }
  contrat = [
    { id: 1, name: 'Alternance' },
    { id: 2, name: 'Autres type de contrat' },
    { id: 3, name: 'CDD' },
    { id: 4, name: 'CDI' },
    { id: 5, name: 'Freelance' },
    { id: 6, name: 'Portage salarial' },
    { id: 7, name: 'Stage' },
  ];
  Statut: { id: string; name: string }[] = [
    { id: '1', name: 'actif' },
    { id: '2', name: 'inactif' },
  ];
  profile = [
    { id: 1, name: 'Oui' },
    { id: 0, name: 'Non' },
  ];
  passeport = [
    { id: 1, name: 'Oui' },
    { id: 0, name: 'Non' },
  ];
  disponibilite = [
    { id: 1, name: 'Immédiate' },
    { id: 3, name: '2 mois' },
    { id: 4, name: '3 mois' },
    { id: 5, name: '4 mois' },
    { id: 6, name: '5 mois' },
  ];
  poste = [
    { id: 1, name: 'A distance' },
    { id: 2, name: 'Hybride' },
    { id: 3, name: 'Sur site' },
  ];
  searchForm: FormGroup = this.createSearchForm();
  idoffre = this.activatedRoute.snapshot.params['id'];
  connectedUser = this.localStorageService.getData('userConnected');
  loadSpinner: boolean = false;
  idappel: any;
  itemsPerPage: number = 5;
  currentPage: number = 1;
  currentSortDirection: number = 1;
  startIndex: number = 0;
  endIndex: number = 5;
  totalItems!: number;
  listappeloffre: any;
  pagination : boolean =false;
  sortAttr = '';
  urlimage: string = environment.baseUrlGalery;
  urlcv: string = environment.baseUrlGaleryCv;
  url: string = environment.baseUrl + '/api';
  loadSpinnerTable: boolean = false;
  currentSortColumn: string = 'name';
  seeMore: boolean = false;
  paysList: any[] = Country.getAllCountries().map((country) => ({
    ...country,
    name: this.translateCountryName(country.name),
  }));
  applyForm: FormGroup = this.createForm();

  countries: any = [];
  stateList!: IState[];
  backGroundColors: string[] = [
    'blue',
    'orange',
    'bleu-clair',
    'pink',
    'rose',
    'jaune',
    'rouge',
  ];
  selectedUserId!: string;
  nameEsn = this.localStorageService.getData('clientConnectedName');
  idclientConnected: any;
  isCollapsed = true;
  iduser: any;
  listconsultant: any;
  skillsList: { name_FR: string }[] = [];
  listsuggestion: any;
  ischecked = true;
  selectedCandidats: any = [];
  constructor(
    private formBuilder: FormBuilder,
    private EsnAppeloffreService: EsnAppeloffreService,
    private spinner: NgxSpinnerService,
    private toastrService: ToastrService,
    private sortDataService: SortDataService,
    private salarieservice: SalarieService,
    private activatedRoute: ActivatedRoute,
    private candidatservice: EsnCandidatService,
    private localStorageService: LocalStorageService
  ) {}
  ngOnInit() {
    this.idclientConnected =
      this.localStorageService.getData('clientConnected');
    this.countries = Country.getAllCountries();
    this.getListSkills();
    this.getListsuggestion();
    this.getlistconsultant();
  }

  getItems(event?: any) {
    if (event) {
      this.startIndex = event.startIndex;
      this.endIndex = event.endIndex;
      this.itemsPerPage = event.itemsPerPage;
      this.currentPage = event.currentPage;
      if (this.searchForm.dirty) {
        this.searchsuggestion();
      } else  if( (this.startIndex !=0 || this.endIndex !=5) || this.pagination == true){        this.pagination = true

        this.getListsuggestion();
      }
    }
  }

  onCountryChange(event: any): void {
    if (event) {
      this.stateList = State.getStatesOfCountry(event.isoCode);
      for (const iterator of this.stateList) {
        iterator.name = iterator.name.replace(' Governorate', '');
      }
    } else {
      this.stateList = [];
      this.searchForm.get('city')?.setValue(null);
    }
  }
  translateCountryName(name: string): string {
    
    return translations[name] || name;
  }
  getListSkills() {
    this.salarieservice.getSkills().subscribe({
      next: (res) => {
        this.skillsList = res.data;
      },
      error: () => {
        this.toastrService.error(serverError);
      },
    });
  }

  getListsuggestion() {
    let dataPyload =
      this.sortAttr == ''
        ? {
            esn_id:this.idclientConnected,
            job_request_id: this.idoffre,
            per_page:this.itemsPerPage,
            page: this.currentPage,
          }
        : {
            ...{
              esn_id: this.idclientConnected,
              job_request_id: this.idoffre,
              per_page: this.itemsPerPage,
              page: this.currentPage,
            },
            ...{
              sort: this.currentSortDirection,
              sortAttribute: this.sortAttr,
            },
          };

    this.spinner.show();
    this.EsnAppeloffreService.getListsuggestion(dataPyload).subscribe({
      next: (response: any) => {
        if (response.data && response.data.data) {
          console.log('response.data', response.data);
          this.listsuggestion = response.data.data
          // .slice(0, this.endIndex);
          this.totalItems = response.data.total;
          this.spinner.hide();
          this.loadSpinnerTable = false;
          console.log('list suggestion', this.listsuggestion);
        }
      },
      error: (error: any) => {
        this.spinner.hide();
        console.error('Error fetching  job offer: ', error);
      },
    });
  }

  sortData(item: string) {
    this.currentSortDirection = this.currentSortDirection === 1 ? 2 : 1;
    let sort = { sort: this.currentSortDirection, sortAttribute: item };
    this.sortAttr = item;
    console.log('sort', sort);
    if (this.searchForm.dirty)
      this.listsuggestion = this.sortDataService.sortArray(
        this.listsuggestion,
        item,
        this.currentSortDirection
      );
    else this.getListsuggestion();
  }
  onSalaryRangeInput(event: any) {
    const value = event.target.value;
    if (value.toLowerCase().endsWith('k')) {
      this.searchForm.controls['desired_salary_range'].setValue(
        this.convertKToNumber(value)
      );
    }
  }
 
 alreadyConverted = false;
 convertKToNumber(value: any): number {
  if (typeof value === 'string' && value.toLowerCase().endsWith('k')) {
    // Si la valeur se termine par 'k'
    const numericValue = parseFloat(value.slice(0, -1));
    if (!isNaN(numericValue)) {
      // Convertir en multipliant par 1000
      this.alreadyConverted = true; // Marquer comme déjà convertie
      return numericValue * 1000;
    }
  } else if (!isNaN(value)) {
    // Si la valeur est déjà un nombre
    if (!this.alreadyConverted) {
      this.alreadyConverted = true; // Marquer comme déjà convertie
      return parseFloat(value) * 1000;
    } else {
      return parseFloat(value); // Retourner la valeur sans multiplier à nouveau
    }
  }

  // Si aucune condition n'est remplie, retourner une valeur par défaut
  return 0; // Ou une autre valeur par défaut appropriée
}
  createSearchForm(data?: any) {
    return this.formBuilder.group({
      name: ['', data?.name],
      post: ['', data?.post],
      skillsOr: [[], data?.skillsOr],
      skillsAnd: [[], data?.skillsAnd],
      manager_name: ['', data?.manager_name],
      client_final_name: ['', data?.client_final_name],
      desired_salary: ['', data?.desired_salary],
      desired_salary_range: ['', data?.desired_salary_range],
      tjm_vente: ['', data?.tjm_vente],
      tjm_vente_range: ['', data?.tjm_vente_range],
      tjm_achat: ['', data?.tjm_achat],
      tjm_achat_range: ['', data?.tjm_achat_range],
      max_experience_years: ['', data?.max_experience_years],
      min_experience_years: ['', data?.min_experience_years],
      mobility: [[], data?.mobility],
      country: [null, data?.country],
      search: [
        '',
        [Validators.pattern(/^("([^"]*"(AND|NOT|,|&&)[^"]*)*"|[^\s"']+)$/)],
      ],
      per_page: this.itemsPerPage,
      page: this.currentPage,
    });
  }

  /* search */
  searchsuggestion() {
    let valueForm = this.searchForm.value;
    valueForm.desired_salary_range = this.convertKToNumber(
      valueForm.desired_salary_range.toString()
    );
    let data = {
      name: valueForm.name,
      post: valueForm.post,
      skillsOr: valueForm.skillsOr,
      skillsAnd: valueForm.skillsAnd,
      manager_name: valueForm.manager_name,
      client_final_name: valueForm.client_final_name,
      tjm_achat: valueForm.tjm_achat,
      tjm_achat_range: valueForm.tjm_achat_range,
      tjm_vente: valueForm.tjm_vente,
      tjm_vente_range: valueForm.tjm_vente_range,
      desired_salary: this.searchForm.value.desired_salary,
      desired_salary_range: this.searchForm.value.desired_salary_range,
      max_experience_years: valueForm.max_experience_years,
      min_experience_years: valueForm.min_experience_years,
      mobility: valueForm.mobility,
      country: valueForm.country,
      per_page: this.itemsPerPage,
      page: this.currentPage,
      search: this.transformSearch(valueForm?.search),

      job_request_id: this.idoffre,
      esn_id: this.idclientConnected,
    };
    console.log('data', data);

    this.spinner.show();
    this.EsnAppeloffreService.searchconsultantsuggestion(data).subscribe({
      next: (resSearch) => {
        console.log('response searchhhhhhhhhh', resSearch);
        if (this.currentPage > 1) {
          this.currentPage = 1;
          this.searchsuggestion();
          console.log('response search', resSearch);
          this.spinner.hide();
        } else {
          this.listsuggestion = resSearch.data.data.slice(0, this.endIndex);
          console.log('response listsuggestion', this.listsuggestion);
          this.totalItems = resSearch.data.total;
          console.log('response totalItems', this.totalItems);
          this.spinner.hide();
        }
      },
      error: (error) => {
        console.log(error);
        this.toastrService.error(serverError);
        this.spinner.hide();
      },
    });
  }
  reset() {
    this.stateList=[];
    this.searchForm.reset();
    this.searchForm = this.createSearchForm();
    this.searchsuggestion();
  }
  transformSearch(search: string): string {
    // Remplace toutes les occurrences de '||' par 'OR'
    search = search.replace(/\|\|/g, ' OR ');

    // Remplace toutes les occurrences de '&&' par ' AND '
    search = search.replace(/&&/g, ' AND ');

    // Remplace toutes les occurrences de '!' par ' NOT '
    search = search.replace(/!/g, ' NOT ');

    // Ajoute des espaces autour des opérations logiques pour éviter des conflits avec les mots
    search = search.replace(/\b(AND|OR|NOT)\b/g, ' $1 ');

    // Remplace les termes entre guillemets doubles par les mêmes termes sans modification
    // et échappe les guillemets simples à l'intérieur des termes non compris entre guillemets
    search = search.replace(/"([^"]+)"|(\S+)/g, (match, p1, p2) => {
      if (p1) {
        return `"${p1}"`;
      } else {
        // Si le terme n'est pas entre guillemets, échappe les guillemets simples à l'intérieur du terme
        const escapedTerm = p2.replace(/"/g, '\\"');
        return `${escapedTerm}`;
      }
    });

    // Supprime les espaces en double pour une meilleure lisibilité
    search = search.replace(/\s+/g, ' ');

    // Renvoie la chaîne de recherche transformée
    return search.trim();
  }

  isSimpleWord(value: string): boolean {
    const simpleWordPattern = /^[a-zA-Z0-9]+(\s[a-zA-Z0-9]+)?$/;
    return simpleWordPattern.test(value);
  }
  downloadFile(type: string, candidat?: any, typeFile?: string) {
    if (this.ischecked) {
      if (type == 'single' && candidat) {
        if (candidat.cv || candidat.file_test) {
          if (typeFile && typeFile != '')
            candidat.file_test = candidat.file_test.split('/')[1];
          const fileUrl = !typeFile
            ? `${this.url}/User/file/gallery_cvs/${candidat.cv}`
            : `${this.url}/ResponseCandidate/GetFile/${candidat.file_test}`; // Replace with your file URL
          this.showGlobalSpinner();
          this.candidatservice.downloadPDF(fileUrl).subscribe(
            (data) => {
              const blob = new Blob([data], {
                type: 'application/octet-stream',
              });
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = !typeFile
                ? `${candidat.ID_user}_${candidat.first_name}_${
                    candidat.last_name
                  }_CV.${candidat!.cv.split('.').pop()}`
                : `${candidat.ID_user}_${candidat.first_name}_${
                    candidat.last_name
                  }_QCM.${candidat!.file_test.split('.').pop()}`;
              document.body.appendChild(a);
              a.click();
              window.URL.revokeObjectURL(url);
              this.hideGlobalSpinner();
            },
            () => {
              this.hideGlobalSpinner();
            }
          );
        } else {
          this.toastrService.info(EmptyCV);
        }
      } else if (this.selectedCandidats.length) {
        if (
          this.selectedCandidats.length == 1 &&
          !this.selectedCandidats[0].cv
        ) {
          this.toastrService.info(EmptyCV);
        } else this.downloadPdfFiles(typeFile);
      } else {
        this.toastrService.info(obligationSelect);
      }
    } else {
      this.toastrService.error(
        'Limite de téléchargements atteinte. Vous ne pouvez télécharger que 3 fichiers.'
      );
    }
  }
  showGlobalSpinner() {
    this.loadSpinner = true;
    this.spinner.show();
  }
  hideGlobalSpinner() {
    this.loadSpinner = false;
    this.spinner.hide();
  }
  /* download files in zip folder */
  downloadPdfFiles(typeFile?: string) {
    const zip = new JSZip();
    const fileUrls = this.selectedCandidats.map(
      (el: {
        cv: string;
        file_test: string;
        first_name: string;
        last_name: string;
        ID_user: string;
      }) => {
        if (!typeFile) {
          return {
            url: `${this.url}/User/file/gallery_cvs/${el.cv}`,
            first_name: el.first_name,
            last_name: el.last_name,
            ID_user: el.ID_user,
            cv: el.cv,
          };
        } else {
          return {
            url: `${this.url}/ResponseCandidate/GetFile/${
              el?.file_test?.split('/')[1]
            }`,
            first_name: el.first_name,
            last_name: el.last_name,
            ID_user: el.ID_user,
            response: el?.file_test?.split('/')[1],
          };
        }
      }
    );
    this.showGlobalSpinner();
    const downloadPromises = fileUrls.map((pdfUrl: any) => {
      return this.candidatservice
        .getPdfContent(pdfUrl.url)
        .toPromise()
        .then(
          (pdfContent: any) => {
            this.hideGlobalSpinner();
            zip.file(
              !typeFile
                ? `${pdfUrl.ID_user}_${pdfUrl.first_name}_${
                    pdfUrl.last_name
                  }_CV.${pdfUrl.cv.split('.').pop()}`
                : `${pdfUrl.ID_user}_${pdfUrl.first_name}_${
                    pdfUrl.last_name
                  }_QCM.${pdfUrl.response.split('.').pop()}`,
              pdfContent
            );
          },
          (err: any) => {
            this.hideGlobalSpinner();
          }
        );
    });

    Promise.all(downloadPromises).then(() => {
      zip.generateAsync({ type: 'blob' }).then((content) => {
        if (!typeFile) {
          saveAs(content, 'RH_Profiles_CVs.zip'); // Specify the zip file name here
        } else {
          saveAs(content, 'RH_Profiles_QCMs.zip');
        }
      });
    });
  }
  isDateInFuture(): boolean {
    const availibilityDate = this.applyForm.get('availibility_date')?.value;
    const today = new Date();
    const availibility = new Date(availibilityDate);
    return availibility < today;
  }
  createForm(data?: any) {
    return this.formBuilder.group({
      commercial_argument: [data ? data.commercial_argument : ''],
      tjm_vente: [data ? data.tjm_vente : ''],
      availibility_date: [data ? data.availibility_date : ''],
      user_id: [data ? data.user_id : null],
    });
  }
  postuleroffre() {
    let data = {
      company_id: this.idclientConnected,
      user_id: this.selectedUserId,
      job_request_id: this.idappel,
    };
    console.log('data', data);
    this.EsnAppeloffreService.applyJob(data).subscribe({
      next: (res: any) => {
        console.log('res', res);
        this.toastrService.success(
          'votre candidature a été envoyé avec succès.'
        );
      },
      error: (error) => {
        console.log(error.error.message);
        if (error.error.message === 'candidature already exist.') {
          this.toastrService.error('Candidature existe déjà');
        }
        if (error.error.message === 'the job offer has been deactivated.') {
          this.toastrService.error(
            "La postulation n'est pas autorisée car l'appel d'offres est désactivé."
          );
        }
      },
    });
  }
  getlistconsultant() {
    console.log('nameEsn', this.nameEsn);
    this.EsnAppeloffreService.getlistconsultantbyoffre(this.nameEsn).subscribe({
      next: (res: any) => {
        this.listconsultant = res.data;
        this.listresponsablesWithDisplayName();
        console.log('list consultant by offre', this.listconsultant);
      },
      error: (error) => {
        console.log(error);
      },
    });
  }
  listresponsablesWithDisplayName() {
    this.listconsultant.map((el: any) => {
      el.name = `${el.first_name} ${el.last_name}`;
    });
  }
  open(suggestion: any) {
    console.log(suggestion);
    this.idappel = suggestion.id;
    console.log(this.idappel);
  }

  getconsultantid(e: any, userId: string) {
    if (e.target.checked) {
      this.selectedUserId = userId;

      console.log('Selected user id:', this.selectedUserId);

      // Décocher toutes les autres cases sauf celle qui a été cochée
      this.deselectOtherCheckboxes(userId);
    } else {
      // La case est décochée, vous pouvez ajouter un code supplémentaire si nécessaire
      console.log('Checkbox unchecked');
    }
  }
  deselectOtherCheckboxes(currentUserId: string) {
    this.listconsultant.forEach((consultant: any) => {
      if (consultant.id !== currentUserId) {
        consultant.checked = false; // Ajoutez une propriété "checked" à votre objet consultant si elle n'existe pas
      }
    });
  }
}
